<template>
    <main id="teinte">
        <section id="teinteDesktop">
            <div id="Teinte" class="rel">
                <section id="productsModule" :class="relatedProducts()" v-if="this.$route.name === 'Module'">
                    <h2 id="title" class="uppercase txtCenter ff-medium rel">
                        {{ $t("modulePage.productsModule") }}
                        <button
                            id="edit"
                            class="btn abs pointer mobileNot ff-light uppercase"
                            @click="addRelatedItem"
                            v-if="
                                (product && (product.type.name === 'product' && hasAccessUpdate('product_manager'))) ||
                                    (product && (product.type.name === 'module' && hasAccessUpdate('module_manager')))
                            "
                        >
                            {{ $t("product.manage") }}
                        </button>
                    </h2>

                    <!-- DESKTOP -->
                    <section class="flexContainer fw-w mobileNot tabletNot" v-if="getRelProductsLength > 0">
                        <swiper :options="swiperOption" ref="mySwiper" class="full">
                            <swiper-slide
                                v-for="(products, index) in getRelatedProducts"
                                :key="products.id"
                                class="modulesWrapper flexContainer fd-c ai-c jc-fs"
                            >
                                <div class="txtCenter slideContent" @mouseover="onHoverRelProduct(index);">
                                    <figure>
                                        <img
                                            :src="getImgPath(products.figures.small, 'small')"
                                            alt=""
                                            class="center imgSlide"
                                            style="max-width: 150px"
                                        />
                                    </figure>
                                    <p class="ff-bold capitalize name">{{ getTranslate(products.terms.name) }}</p>
                                </div>
                                <transition name="fade">
                                    <div @click="toModuleProduct(products.id, products.type.name);" class="pointer">
                                        <div
                                            class="roll-over box-overlay flexContainer full mobileNot tabletNot"
                                            v-if="rollIndex3 === index"
                                            @mouseleave="onHoverLeave"
                                        >
                                            <div class="txtCenter center">
                                                <h4 class="ff-medium">{{ getTranslate(products.terms.name) }}</h4>
                                                <p
                                                    class="ff-light"
                                                    v-if="products.type.name != 'module' && products.infosArticle.hasOwnProperty('client_ref1')"
                                                >
                                                    {{ products.infosArticle.client_ref1.componentProperty.value }}
                                                </p>
                                                <p
                                                    class="ff-light"
                                                    v-if="products.type.name != 'module' && products.infosArticle.hasOwnProperty('client_ref1')"
                                                >
                                                    {{ products.infosArticle.diam_ref1.componentProperty.value }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </swiper-slide>
                            <div class="swiper-button-prev" slot="button-prev" v-if="getRelProductsLength > 6"></div>
                            <div class="swiper-button-next" slot="button-next" v-if="getRelProductsLength > 6"></div>
                            <div class="swiper-pagination" slot="pagination" v-if="getRelModulesLength > 6"></div>
                        </swiper>
                    </section>
                </section>
                <section class="mobileOnly flexContainer" v-if="getRelProductsLength > 0">
                    <swiper :options="swiperOptionMobile" ref="mySwiper">
                        <swiper-slide v-for="products in getRelatedProducts" :key="products.id">
                            <div class="txtCenter slideContent">
                                <div class="linkToItem block abs pointer full" @click="toModuleProduct(products.id, products.type.name);"></div>
                                <figure><img :src="getImgPath(products.figures.small, 'small')" alt="" class="center imgSlide" /></figure>
                                <p class="ff-bold capitalize">{{ getTranslate(products.terms.name) }}</p>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </section>
                <section class="mobileOnly" v-if="getRelModulesLength > 0">
                    <h2 class=" relModule uppercase ff-medium" v-if="getRelModulesLength > 0">{{ $t("modulePage.moduleProduct") }}</h2>
                    <swiper :options="swiperOptionMobile" ref="mySwiper">
                        <swiper-slide v-for="modules in getRelatedModules" :key="modules.id">
                            <div class="txtCenter slideContent">
                                <div class="linkToItem block abs pointer full" @click="toModuleProduct(modules.id, modules.type.name);"></div>
                                <figure><img :src="getImgPath(modules.figures.small, 'small')" alt="" class="center imgSlide" /></figure>
                                <p class="ff-bold capitalize">{{ getTranslate(modules.terms.name) }}</p>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </section>
                <section id="otherProducts" class="rel mobileNot tabletNot" v-if="this.$route.name === 'Product'">
                    <h2 id="title" class="uppercase txtCenter ff-medium rel">
                        {{ $t("modulePage.moduleProduct") }}
                        <button id="edit" class="btn abs pointer mobileNot ff-light uppercase" @click="addRelatedItem">
                            {{ $t("product.manage") }}
                        </button>
                    </h2>
                    <section class="flexContainer fw-w mobileNot tabletNot" v-bind="displayFolModules()">
                        <swiper :options="swiperOption" ref="mySwiper" class="full">
                            <swiper-slide
                                v-if="getRelModulesLength"
                                v-for="(modules, index) in getRelatedModules"
                                :key="modules.id"
                                class="modulesWrapper flexContainer fd-c ai-c jc-fs"
                                :class="itemClassModule(index)"
                            >
                                <div class="txtCenter slideContent" @mouseover="onHoverModule(index);">
                                    <figure>
                                        <img
                                            :src="getImgPath(modules.figures.small, 'small')"
                                            alt=""
                                            class="center relatedPicture"
                                            style="max-width: 150px"
                                        />
                                    </figure>
                                    <p class="ff-bold capitalize name">{{ getTranslate(modules.terms.name) }}</p>
                                </div>
                                <transition name="fade">
                                    <div @click="toModuleProduct(modules.id, modules.type.name);" class="pointer">
                                        <div
                                            class="roll-over box-overlay flexContainer full mobileNot tabletNot"
                                            v-if="rollIndex2 === index"
                                            @mouseleave="onHoverLeave"
                                        >
                                            <div class="txtCenter center">
                                                <h4 class="ff-medium">{{ getTranslate(modules.terms.name) }}</h4>
                                                <p
                                                    class="ff-light"
                                                    v-if="modules.type.name != 'product' && modules.infosArticle.hasOwnProperty('client_ref1')"
                                                >
                                                    {{ modules.infosArticle.client_ref1.componentProperty.value }}
                                                </p>
                                                <p
                                                    class="ff-light"
                                                    v-if="modules.type.name != 'product' && modules.infosArticle.hasOwnProperty('client_ref1')"
                                                >
                                                    {{ modules.infosArticle.diam_ref1.componentProperty.value }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </swiper-slide>
                            <div class="swiper-button-prev" slot="button-prev" v-if="getRelModulesLength > 6"></div>
                            <div class="swiper-button-next" slot="button-next" v-if="getRelModulesLength > 6"></div>
                            <div class="swiper-pagination" slot="pagination" v-if="getRelModulesLength > 6"></div>
                        </swiper>
                    </section>
                </section>
            </div>
        </section>
        <ModalRelated
            v-if="showModal"
            :itemType="product.type"
            :relatedItem="relatedItem"
            @closeModal="modalClose($event);"
            @relatedItemSaved="addedItem($event);"
        ></ModalRelated>
    </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Globals from "../globals.js";
import ModalRelated from "../modal/modalRelated.vue";
import TryLoadMixin from "@/mixins/TryLoadMixin";

export default {
    data: () => ({
        showModal: false,
        swiperOption: {
            direction: "horizontal",
            loop: true,
            grabCursor: true,
            setWrapperSize: true,
            autoHeight: false,
            pagination: ".swiper-pagination",
            prevButton: ".swiper-button-prev",
            nextButton: ".swiper-button-next",
            paginationClickable: true,
            mousewheelControl: true,
            observeParents: true,
            debugger: true,
            slidesPerView: 6
        },
        swiperOptionMobile: {
            direction: "horizontal",
            loop: true,
            setWrapperSize: true,
            autoHeight: false,
            pagination: ".swiper-pagination",
            paginationClickable: true,
            mousewheelControl: true,
            // observeParents: true,
            debugger: true
        },
        rollIndex: null,
        rollIndex2: null,
        rollIndex3: null,
        itemType: null
    }),
    mixins: [TryLoadMixin],
    components: {
        ModalRelated
    },
    watch: {
        "$route.params.id"() {
            this.loadRelated();
        }
    },
    methods: {
        ...mapActions("items/", {
            loadRelatedProducts: "getRelatedProducts",
            loadRelatedModules: "getRelatedModules"
        }),
        modalClose(close) {
            this.showModal = close;
        },
        addedItem(relatedItem) {
            this.relatedItemSaved = relatedItem;
            location.reload();
        },
        addRelatedItem() {
            this.showModal = true;
            this.relatedItem = true;
        },
        toModuleProduct(id, type) {
            if (type === "product") {
                this.$router.push("/product/" + id);
            } else if (type === "module") {
                this.$router.push("/module/" + id);
            }
        },
        onHoverModule(index) {
            this.rollIndex2 = index;
        },
        bordered(index) {
            return (index + 1) % 6 ? "bordered" : "";
        },
        row(index) {
            return index + 1 <= 6 ? "firstRow" : "secondRow";
        },
        itemClassModule(index) {
            return this.bordered(index) + " " + this.row(index);
        },
        hover(index) {
            if (this.rollIndex === index || this.rollIndex2 === index || this.rollIndex3 === index) {
                return "hover-parent";
            }
            if (this.rollIndex === index + 1 || this.rollIndex2 === index + 1 || this.rollIndex3 === index + 1) {
                return "hover-parent";
            } else {
                return "";
            }
        },
        displayFolModules() {
            if (this.getRelModulesLength <= 6) {
                this.swiperOption.loop = false;
                this.swiperOption.grabCursor = false;
            } else {
                this.swiperOption.loop = true;
                this.swiperOption.grabCursor = true;
            }
        },
        onHoverLeave() {
            this.rollIndex = null;
            this.rollIndex2 = null;
            this.rollIndex3 = null;
        },
        onHoverRelProduct(index) {
            this.rollIndex3 = index;
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        relatedProducts() {
            if (this.getRelProductsLength <= 6) {
                this.swiperOption.loop = false;
                this.swiperOption.grabCursor = false;
            } else {
                this.swiperOption.loop = true;
                this.swiperOption.grabCursor = true;
            }
        },
        async loadRelated() {
            await this.loadRelatedProducts({ id: this.$route.params.id });
            await this.loadRelatedModules({ id: this.$route.params.id });
        }
    },
    computed: {
        ...mapGetters({
            getAllModules: "modules/getAllModules",
            getModules: "modules/getModules",
            getModulesLength: "modules/getModulesLength",
            getAllProducts: "products/getAllProducts",
            getProducts: "products/getProducts",
            getRelProductsLength: "items/getRelProductsLength",
            getRelModulesLength: "items/getRelModulesLength",
            getDetails: "items/getDetails",
            getRelatedProducts: "items/getRelatedProducts",
            getRelatedModules: "items/getRelatedModules",
            getImgEditor: "items/getImgEditor"
        }),
        product() {
            return this.getDetails(this.$route.params.id);
        }
    },
    created() {
        this.loadRelated();
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.imgSlide {
    @media only screen and (max-width: 767px) {
        max-width: 135px;
    }
}

#teinte {
    @extend %second-bloc;
    @extend %primary-text;
    margin-right: 30px;
    margin-left: 30px;

    #teinteDesktop {
        #title {
            font-size: 18px;
            margin-top: 30px;
        }

        #edit {
            font-size: 1.4rem;
            right: 0;
            top: -7px;
            margin-right: 50px;
        }
    }
}

#otherProducts,
#productsModule {
    padding: 30px;

    ul {
        padding: 0;
        margin-bottom: 40px;

        li {
            list-style: none;
            font-size: 1.6rem;
            padding-bottom: 0.4rem;
            color: #95989a;
            font-weight: 300;
            border-bottom: 1px solid #f4f4f4;
            z-index: 3;

            &:hover {
                cursor: pointer;
                color: #343434;
                transition: all 0.3s;
            }

            &:first-child {
                padding-right: 10px;
            }

            &:nth-child(3) {
                padding-left: 10px;
            }
        }

        &:after {
            content: "";
            height: 1px;
            display: block;
            width: 100%;
            background: #eee;
            position: absolute;
            top: 23px;
            z-index: 2;
        }
    }

    .slideContent {
        p {
            font-size: 1.4rem;
        }

        .ff-bold {
            margin-top: 10px;
            margin-bottom: 5px;
        }

        .ff-light {
            margin-top: 0;
        }

        &:hover {
            .name {
                color: transparent;
            }
        }
    }

    .active {
        border-bottom: 2px solid #343434;
        color: #343434;
        font-weight: 500;
        transition: all 0.2s;
    }

    .roll-over {
        border-radius: 5px;
        font-size: 1.4rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        div {
            max-width: 230px;
            display: block;
            margin: auto;
            padding-top: 15px;
        }

        .btn-hover {
            bottom: 0px;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        p {
            margin: 5px 0;
        }

        h4 {
            margin-bottom: 5px;
        }

        .btn {
            background: transparent;
            border-radius: 2em;
            border: 1px solid #343434;
            padding: 0.65em 1.7em;
            font-size: 1.4rem;
            cursor: pointer;
            margin-bottom: 10px;

            &-dark {
                background: #343434;
                color: #fff;
                border: 1px solid #343434;
            }
        }

        figure {
            height: 200px;

            img {
                max-width: 100%;
                height: inherit;
            }
        }

        h3 {
            font-size: 1.8rem;
        }

        .slide-fade-enter-active {
            transition: all 0.3s ease;
        }

        .slide-fade-leave-active {
            transition: all 0.2s cubic-bezier(1, 0.5, 0.5, 1);
        }

        .slide-fade-enter,
        .slide-fade-leave-to {
            transform: translateY(10px);
            opacity: 0;
        }

        #relatedItems {
            max-width: 300px;
            margin-left: 30px;
            margin-bottom: 30px;
        }

        .swiper-container-horizontal {
            .swiper-pagination {
                margin-top: 10px;
                position: initial;
            }
        }
    }
}

@media only screen and (max-width: 767px) {
    .linkToItem {
        height: 100%;
        // background: red;
        z-index: 50;

        #figure {
            img {
                height: auto;
            }
        }
    }
    .relModule {
        margin-left: 20px;
        margin-right: 20px;
    }
    .swiper-pagination {
        margin-bottom: 10px;
        position: initial;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .linkToItem {
        height: 100%;
        // background: red;
        z-index: 50;

        #figure {
            img {
                height: auto;
            }
        }
    }
    .relModule {
        margin-left: 30px;
        margin-right: 30px;
    }
    .swiper-pagination {
        margin-bottom: 10px;
        position: initial;
    }
}
</style>



// WEBPACK FOOTER //
// Related.vue?304f3f62